import { useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { useSetAtom } from 'jotai';
import { fetchPromptsActionAtom } from '@/stores/settingsStore';
import { PromptList } from './prompts';

interface SettingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function SettingsDialog({ open, onOpenChange }: SettingsDialogProps) {
  const fetchPrompts = useSetAtom(fetchPromptsActionAtom);

  useEffect(() => {
    fetchPrompts();
  }, [fetchPrompts]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='sm:max-w-[720px] max-h-[90vh] overflow-hidden pb-6'>
        <DialogHeader className=''>
          <DialogTitle>Settings</DialogTitle>
          <DialogDescription>
            Manage system and user prompts used throughout the app.
          </DialogDescription>
        </DialogHeader>
        <div className='overflow-y-auto max-h-[70vh]'>
          <PromptList />
        </div>
      </DialogContent>
    </Dialog>
  );
}
